import React, {Component} from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Table } from 'react-bootstrap'
import './PaymentPage.css'

export default class AdjustmentPayment extends Component {
  static propTypes = {
    adjustment: PropTypes.object,
    onPayClick: PropTypes.func
  }

  render () {
    const { adjustment, onPayClick } = this.props
    return (<div className="col-md-offset-1 col-md-10">
      <div className="panel panel-default panel-border">
        <div className="panel-body">
          <h2 className="title">Riepilogo</h2>

          <div className="row">
            <div className="col-md-12 hidden-md hidden-lg">
              <div className="card-marks">
                <div className="capiton cart-caption">
                  <div className="col-md-4">
                    <h4>
                      <span className="text-left">
                        Pagamento 2018
                      </span>
                    </h4>
                  </div>

                  <div className="col-md-4">
                    <h4>
                      <strong>Prezzo </strong>
                      <span className="text-left">
                        € {Number(adjustment.total).toLocaleString('it-IT', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                      </span>
                    </h4>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <Table responsive className="hidden-xs hidden-sm">
            <thead>
              <tr>
                <th>Prodotto</th>
                <th>Prezzo</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="text-left">
                  <span>
                    Pagamento 2018
                  </span>
                </td>
                <td className="text-left">
                  € {Number(adjustment.total).toLocaleString('it-IT', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                </td>
              </tr>
            </tbody>
          </Table>

          <div className="row">
            <div className="text-center">
              <h3>Totale: € {Number(adjustment.total).toLocaleString('it-IT', {minimumFractionDigits: 2, maximumFractionDigits: 2, maximumFractionDigits: 2})}</h3>
            </div>
          </div>

          <button onClick={() => onPayClick()} type="button" className="btn btn-green">
            Acquista
          </button>

        </div>
      </div>
    </div>)
  }
}



// WEBPACK FOOTER //
// ./src/containers/UserArea/Checkout/AdjustmentPayment.js